'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useTeachingPopoverTrigger_unstable", {
    enumerable: true,
    get: function() {
        return useTeachingPopoverTrigger_unstable;
    }
});
const _reactpopover = require("@fluentui/react-popover");
const useTeachingPopoverTrigger_unstable = (props)=>{
    const state = (0, _reactpopover.usePopoverTrigger_unstable)(props);
    return state;
};
